import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import styles from './DeviceStatus.less';
import { Row, Col, Cascader } from 'antd';
import DatePickerComponent from '../DatePicker';
import cityOptions from '../../const/citys';
import { getBrokenLineOption } from '../../const/EchartsConst';
import DeviceOnlineCount from './StatisticsBtnGroup';
import { observable, action } from 'mobx';

@inject('statisticsStore')
@observer
class DeviceStatus extends React.Component {
  @observable timeMode = 0;
  @observable currentData = moment().add(-1, 'day');
  @observable cityData = [];

  componentWillMount() {
    this.timeMode = 0;
    this.currentData = moment().add(-1, 'day');
  }

  componentDidMount() {
    this.props.statisticsStore.loadDeviceStatus(
      moment()
        .add(-1, 'day')
        .format('YYYYMMDD'),
      moment()
        .add(-1, 'day')
        .format('YYYYMMDD')
    );
  }

  @action
  getStartTime(mode, data) {
    if (mode === 0) {
      return moment(data || this.currentData).format('YYYYMMDD');
    } else {
      return moment(data || this.currentData)
        .startOf('month')
        .format('YYYYMMDD');
    }
  }
  @action
  getEndTime(mode, data) {
    if (mode === 0) {
      return moment(data || this.currentData).format('YYYYMMDD');
    } else {
      return moment(data || this.currentData)
        .endOf('month')
        .format('YYYYMMDD');
    }
  }

  @action.bound
  timeModeChange(value) {
    const startDate = this.getStartTime(value, this.currentData);
    const endDate = this.getEndTime(value, this.currentData);
    this.props.statisticsStore.loadDeviceStatus(
      startDate,
      endDate,
      [...this.cityData][0],
      [...this.cityData][1] || undefined
    );
    this.timeMode = value;
  }

  @action.bound
  timeChange(data) {
    if (data) {
      this.currentData = data;
      const startDate = this.getStartTime(this.timeMode, this.currentData);
      const endDate = this.getEndTime(this.timeMode, this.currentData);
      this.props.statisticsStore.loadDeviceStatus(
        startDate,
        endDate,
        [...this.cityData][0],
        [...this.cityData][1] || undefined
      );
    }
  }

  @action.bound
  cityChange(value) {
    const startDate = this.getStartTime(this.timeMode, this.currentData);
    const endDate = this.getEndTime(this.timeMode, this.currentData);
    if (value[0] === 'all') {
      this.cityData = [];
      this.props.statisticsStore.loadDeviceStatus(startDate, endDate);
    } else {
      this.cityData = value;
      this.props.statisticsStore.loadDeviceStatus(
        startDate,
        endDate,
        value[0],
        value[1] || undefined
      );
    }
  }

  render() {
    const { loadOnlineCountModalData } = this.props.statisticsStore;
    let startDate = this.getStartTime(this.timeMode, this.currentData);
    let endDate = this.getEndTime(this.timeMode, this.currentData);
    return (
      <div className={styles.StatisticsDeviceStatus}>
        <Row>
          <Col span={3} className={styles.searchTitle}>
            设备上线次数统计
          </Col>
        </Row>
        <Row className={styles.searchItem}>
          <Col span={2} style={{ paddingLeft: 20 }}>
            统计区域:
          </Col>
          <Col span={4}>
            <Cascader
              options={cityOptions}
              placeholder="请选择统计区域"
              defaultValue={['all']}
              onChange={this.cityChange}
              changeOnSelect
            />
          </Col>
          <Col offset={1} span={2}>
            统计日期:
          </Col>
          <Col span={5}>
            <DatePickerComponent onChange={this.timeChange} />
          </Col>
          <Col span={3} className={styles.btnContainer}>
            <div
              onClick={() => this.timeModeChange(0)}
              className={
                this.timeMode === 0 ? styles.activeBtn : styles.defaultBtn
              }
            >
              按日
            </div>
            <div
              onClick={() => this.timeModeChange(1)}
              className={
                this.timeMode === 1 ? styles.activeBtn : styles.defaultBtn
              }
            >
              按月
            </div>
          </Col>
        </Row>
        <div className={styles.echartContainer}>
          <ReactEcharts
            option={getBrokenLineOption(
              this.props.statisticsStore.deviceStatusArr
            )}
            notMerge={true}
            lazyUpdate={true}
            style={{ height: '200px', width: '100%' }}
            className={styles.echartsItem}
          />
        </div>
        <Row />
        <DeviceOnlineCount
          btnGroup={this.props.statisticsStore.deviceStatusBtnGroup}
          title={'设备上线次数'}
          handelClick={loadOnlineCountModalData}
          start={startDate}
          end={endDate}
          cityData={[...this.cityData]}
        />
      </div>
    );
  }
}
export default DeviceStatus;



// WEBPACK FOOTER //
// ./src/components/Statistics/DeviceStatus.js